import { createSlice } from '@reduxjs/toolkit';
import Session from '../../Utils/Sessions';

const initialState = {
    user: {
        id: null,
        profile_image: '',
        profile: null,
        full_name: null,
    },
    token: null,
    isAuthenticated: false,
    message: '',
    permissions: (() => {
        try {
            const storedPermissions = Session.get('permissions');
            return storedPermissions ? JSON.parse(storedPermissions) : [];
        } catch (error) {
            console.error('Error loading permissions from session:', error);
            return [];
        }
    })(),
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action) => {
          

            const { token, user_details, message, permissions } = action.payload;
            

            state.user = {
                id: user_details?.id ?? null,
                profile_image: user_details?.profile_image?.trim() ?? '',
                profile: user_details?.profile ?? null,
                full_name: user_details?.full_name ?? null,   // ✅ correctly mapped
            };

            state.token = token ?? null;
            state.isAuthenticated = !!token;
            state.message = message ?? '';
            state.permissions = permissions ?? [];

            // ✅ Save in session
            Session.set('token', token);
            Session.set('profile_image', user_details?.profile_image?.trim() ?? '');
            Session.set('full_name', user_details?.full_name ?? '');
            Session.set('type', user_details?.profile);
            // Session.set('permissions', JSON.stringify(permissions ?? []));
        },

        updatePermissions: (state, action) => {
          
            state.permissions = action.payload?.permissions ?? [];
          
        },

        logout: (state) => {
            state.user = initialState.user;
            state.token = null;
            state.isAuthenticated = false;
            state.message = '';
            state.permissions = [];

            Session.remove('token');
            Session.remove('profile_image');
            Session.remove('full_name');
            Session.remove('type');
            Session.remove('permissions');
            Session.remove('selectedEmployeeData');
        },
    },
});

export const { setCredentials, logout, updatePermissions } = authSlice.actions;

export default authSlice.reducer;
